import { TraitTypeSelect } from '../traitTypes/TraitTypeSelect';
import { TraitRegistryCategory } from '../TraitRegistryCategory';
export class TraitRegistryCssBlock extends TraitRegistryCategory {
    label = 'Block';
    constructor(parent) {
        super(parent);
        super.init();
    }
    verticalAlign = () => new TraitTypeSelect( /*{
           default: 'baseline',
           label: 'Vertikale Ausrichtung',
           init: 'middle',
           select: [['baseline'], ['middle'], ['bottom'], ['text-bottom'], ['sub'], ['super'], ['top'], ['text-top']]
    }*/);
}
